"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("./store/redux/store");
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const NavigationWeb_1 = require("./components_web/NavigationWeb");
const account_1 = require("./store/redux/account");
const react_native_1 = require("react-native");
const authStorage_1 = require("./services/authStorage");
require("./components_web/styles/input.scss");
const react_i18next_1 = require("react-i18next");
const i18n_1 = require("./i18n");
const Root = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        dispatch((0, account_1.setPlatformAction)({ platform: react_native_1.Platform.OS }));
        async function fetchToken() {
            const storedToken = await (0, authStorage_1.authStorageManager)(authStorage_1.secureStorageActionTypes.GET, authStorage_1.secureStorageKeys.ACCESS_TOKEN);
            const expDate = await (0, authStorage_1.authStorageManager)(authStorage_1.secureStorageActionTypes.GET, authStorage_1.secureStorageKeys.EXP_DATE);
            if (storedToken && expDate) {
                dispatch((0, account_1.authenticateAction)({
                    accessToken: storedToken,
                    expDate: expDate
                }));
            }
        }
        fetchToken();
    });
    return (0, jsx_runtime_1.jsx)(NavigationWeb_1.NavigationWeb, {});
};
const FlyWayWeb = () => {
    return ((0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store_1.store, children: (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, { i18n: i18n_1.i18nInit, children: (0, jsx_runtime_1.jsx)(Root, {}) }) }));
};
exports.default = FlyWayWeb;
